import axios from 'axios';

export const USERS_URL = '/users/getUsersList';
export const GET_PARTNERS_OPTIONS_URL = 'partners/getPartnersList';
export const GET_PRACTICE_AREA_OPTIONS_URL = '/users/getDropdownPracticeArea';
export const GET_USERS_DATA_FILE = '/users/getUsersDataForExcel';

export function findUsers(queryParams, cancellationHandlers) {
  return axios.get(USERS_URL, {params: queryParams, ...cancellationHandlers});
}

export function getPartnersOptions() {
  return axios.get(GET_PARTNERS_OPTIONS_URL);
}

export function getPracticeAreaOptions() {
  return axios.get(GET_PRACTICE_AREA_OPTIONS_URL);
}

export function getUsersDataFile(queryParams) {
  return axios.get(GET_USERS_DATA_FILE, {params: queryParams});
}
